<template>
  <div class="c-input">
    <label>
      <span
        class="c-input__placeholder"
        v-bind:class="{ 'c-input__placeholder--compleeted': inputValue || focusState }"
      >
        {{ placeholder }}
      </span>
      <input
        :type="type"
        v-on:input="$emit('inputChange', inputValue)"
        v-on:focus="focusState = !focusState"
        v-on:blur="focusState = !focusState"
        v-model="inputValue"
        class="c-input__field"
      />
    </label>
  </div>
</template>
<script>
export default {
  data() {
    return {
      inputValue: null,
      focusState: false,
    };
  },
  props: {
    type: {
      default: "text",
    },
    value: {
      default: null,
    },
    placeholder: {
      default: "",
    },
  },
  watch: {
    value() {
      this.inputValue = this.value;
    },
  },
};
</script>
<style lang="scss">
@import "../_variables.scss";
.c-input {
  position: relative;
  margin: 1rem 0.5rem 0 0.5rem;
  // z-index: -1;
  // &::before,&::after{
  //     content: ' ';
  //     display: block;
  //     height: .5rem;
  //     border-left: 1px solid $darkGray;
  //     width: 1px;
  //     position: absolute;
  //     bottom: 0rem;
  // }
  // &::before{
  //     right: 0;
  // }
  &__placeholder {
    position: absolute;
    bottom: 0.5rem;
    left: 2rem;
    font-size: 1.25rem;
    transition: bottom 0.25s;
    &--compleeted {
      display: none;
    }
  }
  &__field {
    border: 0;
    outline: 0;
    width: 100%;
    border: 1px solid $black;
    padding: 0.65rem 1rem;
    font-size: 1.25rem;
    font-weight: 100;
  }
}
</style>
